import React from 'react';
import styled from 'styled-components';
import { DEVICES } from '../../const';
import logo from '../../assets/logo.png';


const Inner = styled.div`
  margin: auto;
  text-align: center;
  padding: 3rem 0;

  @media ${DEVICES.mobile} {
  }

  @media ${DEVICES.tablet} {
  }

  @media ${DEVICES.large} {
    max-width: 1200px;
  }
`;

const TitleBold = styled.div`
  font-weight: 700;

  @media ${DEVICES.mobile} {
    font-size: 1.8rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 1.5rem;
  }

  @media ${DEVICES.laptop} {
    font-size: 1.8rem;
  }
`;

const TitleNormal = styled.div`
  font-weight: 500;

  @media ${DEVICES.mobile} {
    font-size: 1.8rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 1.5rem;
  }

  @media ${DEVICES.laptop} {
    font-size: 1.8rem;
  }
`;

const ProgramList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding-top: 3rem;
  align-items: center;
`;

const ProgramListItem = styled.div`
  padding: 2rem;
  @media ${DEVICES.mobile} {
    width: 100px;
  }

  @media ${DEVICES.tablet} {
    width: 100px;
  }

  @media ${DEVICES.laptop} {
    width: 128px;
  }
`;

const ProgramListItemTitle = styled.div`
  min-width: 100px;
`;

const ProgramListItemImg = styled.img`
  width: 100%;
  margin-top: 1rem;
`;


export default function ProgramListBanner() {
  return (
    <Inner>
      <TitleNormal>캥거루짐의</TitleNormal>
      <TitleBold>8가지 운동 프로그램</TitleBold>
      <ProgramList>
        <ProgramListItem>
          <ProgramListItemTitle>
            개인수업
          </ProgramListItemTitle>
          <ProgramListItemImg src={logo} />
        </ProgramListItem>
        <ProgramListItem>
          <ProgramListItemTitle>
            축구
          </ProgramListItemTitle>
          <ProgramListItemImg src={logo} />
        </ProgramListItem>
        <ProgramListItem>
          <ProgramListItemTitle>
            농구
          </ProgramListItemTitle>
          <ProgramListItemImg src={logo} />
        </ProgramListItem>
        <ProgramListItem>
          <ProgramListItemTitle>
            줄넘기
          </ProgramListItemTitle>
          <ProgramListItemImg src={logo} />
        </ProgramListItem>
        <ProgramListItem>
          <ProgramListItemTitle>
            테니스
          </ProgramListItemTitle>
          <ProgramListItemImg src={logo} />
        </ProgramListItem>
        <ProgramListItem>
          <ProgramListItemTitle>
            인라인
          </ProgramListItemTitle>
          <ProgramListItemImg src={logo} />
        </ProgramListItem>
        <ProgramListItem>
          <ProgramListItemTitle>
            생활체육
          </ProgramListItemTitle>
          <ProgramListItemImg src={logo} />
        </ProgramListItem>
        <ProgramListItem>
          <ProgramListItemTitle>
            기능성 훈련
          </ProgramListItemTitle>
          <ProgramListItemImg src={logo} />
        </ProgramListItem>
      </ProgramList>
    </Inner>
  )
}